// Dependencies
var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
var format = require('string-format');
var queryString = require('query-string');

// App
var ContactView = require('app/public-app/apps/listing-detail/contact-view');
var ClientFeedbackView = require('app/public-app/apps/common/client-feedback-view');
var ClientFeedback = require('app/public-app/apps/entities').ClientFeedback;
var DetailMapView = require('app/react-app/apps/listings/detail/detail-map-view');
var Gallery = require('app/common/behaviors/gallery');
var Affix = require('app/common/behaviors/affix');
var Tooltips = require('app/common/behaviors/tooltips');
var Template = require('app/utils/template');
var Helpers = require('app/helpers');
var HelperUtils = require('app/helpers/utils');
var initials = require('app/utils/string').initials;
var DetailTpl = require('./templates/detail.html');

// Channels
var channel = Radio.channel('global');

var DetailView = Marionette.LayoutView.extend({
    className: 'public-listing-detail',
    template: Template(DetailTpl),

    behaviors: {
        ListingPhotos: {
            behaviorClass: Gallery,
            gallerySelector: '[data-ui="photoGallery"]',
            openGallerySelector: '[data-ui="viewPhotos"]',
            galleryOptions: {
                download: false,
            },
        },
        ListingFloorplans: {
            behaviorClass: Gallery,
            gallerySelector: null,
            openGallerySelector: '[data-ui="viewFloorplans"]',
            galleryOptions: function() {
                return {
                    dynamic: true,
                    dynamicEl: this.getListingFloorplans(),
                };
            },
        },
        StickyContacts: {
            behaviorClass: Affix,
            offset: {
                top: function() {
                    return $('.primary-listing-info').offset().top;
                },
                bottom: function() {
                    return $(document).height() - $('.footer').offset().top + 30;
                },
            },
        },
        Tooltips: {
            behaviorClass: Tooltips,
        },
    },

    regions: {
        map: '[data-region="map"]',
        clientFeedback: '[data-region="client-feedback"]',
        clientFeedbackSuccess: '[data-region="client-feedback-success"]',
    },

    ui: {
        viewMap: '[data-ui="viewMap"]',
        viewFloorplans: '[data-ui="viewFloorplans"]',
        viewPhotos: '[data-ui="viewPhotos"]',
        locationBlock: '[data-ui="locationBlock"]',
        contactAgent: '[data-ui="contactAgent"]',
    },

    events: {
        'click @ui.viewMap': 'scrollToMap',
        'click @ui.contactAgent': 'contactAgent',
    },

    onShow: function() {
        this.showMap();
        this.showClientFeedback();
        this.setPageTitle();
        this.setHBCondition();
    },

    setHBCondition: function() {
        if (!window.HB) {
            return;
        }

        window.HB.setCustomConditionValue('city', this.model.get('listing').building.city);
        window.HB.setCustomConditionValue('state', this.model.get('listing').building.state);
        window.HB.setCustomConditionValue('market', this.model.get('company').market);
    },

    showMap: function() {
        var listing = this.model.get('listing');
        var neighborhoodGeometry = listing.neighborhood_geometry;

        if (listing.location) {
            this.showChildView(
                'map',
                new DetailMapView({
                    model: this.model,
                    neighborhoodGeometry: neighborhoodGeometry && neighborhoodGeometry.geometry.coordinates[0],
                    showMarker: !(listing.location_neighborhood_only || listing.location_street_only),
                    showCircle: listing.location_street_only,
                    location: { lng: listing.location[0], lat: listing.location[1] },
                    zoom: listing.location_neighborhood_only ? 14 : 16,
                    mapboxAccessToken: channel.request('config:pick', 'MAPBOX_ACCESS_TOKEN'),
                    detailBlock: false,
                    enableNeighborhoodGeometry: listing.location_neighborhood_only && listing.neighborhood_geometry,
                })
            );
        }
    },

    showClientFeedback: function() {
        var listing = this.model.get('listing');
        var query = queryString.parse(this.model.get('queryString'));
        // if urlArgs.length is 5, agentId is the 3rd element (not included if length is 4)
        var urlArgs = this.getOption('urlArgs');
        var agentId = urlArgs && urlArgs.length === 5 ? urlArgs[2] : null;

        if (query.client_listing_id) {
            var clientFeedback = new ClientFeedback({
                unit_id: listing.id,
                client_listing_id: query.client_listing_id,
                agent_id: agentId,
            });
            clientFeedback.fetch().done(
                function() {
                    var clientFeedbackView = new ClientFeedbackView({
                        model: clientFeedback,
                    });
                    this.getRegion('clientFeedback').show(clientFeedbackView);
                }.bind(this)
            );
        }
    },

    setPageTitle: function() {
        var listing = this.model.get('listing');
        var unitNumber = listing.unitNumber ? format(' #{0}', listing.unit_number) : '';
        document.title = format(
            '{0} - {1}{2} - {3}',
            Helpers.getChoiceLabel('layoutChoices', listing.layout),
            listing.public_address,
            unitNumber,
            listing.neighborhood_name
        );
    },

    onSubmitContactSuccess: function() {
        var contactAgentBtn = this.ui.contactAgent;
        var contactButtonText = contactAgentBtn.text();
        contactAgentBtn
            .addClass('btn-success')
            .attr('disabled', true)
            .text('Email Sent!');

        _.delay(
            _.bind(function() {
                contactAgentBtn
                    .removeClass('btn-success')
                    .removeAttr('disabled')
                    .text(contactButtonText);
            }, this),
            3000
        );
    },

    getListingFloorplans: function() {
        return _.map(this.model.get('listing').floorplans, function(item) {
            return { thumb: item.thumbnail, src: item.xlarge };
        });
    },

    scrollToMap: function(e) {
        e.preventDefault();
        $('html, body').animate(
            {
                scrollTop: this.ui.locationBlock.offset().top,
            },
            300
        );
    },

    contactAgent: function(e) {
        e.preventDefault();
        var contacts = new Backbone.Collection(this.model.get('contacts'));

        var contactView = new ContactView({
            contacts: contacts,
            url: format('/p/listing/{0}/contact.json', this.getOption('urlArgs').join('/')),
        });

        this.listenTo(contactView, 'submit:success', this.onSubmitContactSuccess);

        contactView.on('destroy', function() {
            this.stopListening(contactView, 'submit:success');
        });

        channel.request('show:modal', contactView, this);
    },

    getLeaseTerm: function() {
        var leaseTerm;
        var leaseTermMin = this.model.get('listing').lease_term_min;
        var leaseTermMax = this.model.get('listing').lease_term_max;

        if (leaseTermMin && leaseTermMax) {
            if (leaseTermMin == leaseTermMax) {
                return format('{0} months', leaseTermMax);
            }
            leaseTerm = format('{0} months - {1} months', leaseTermMin, leaseTermMax);
        } else if (leaseTermMin) {
            leaseTerm = format('{0} months min', leaseTermMin);
        } else if (leaseTermMax) {
            leaseTerm = format('{0} months max', leaseTermMax);
        }
        return leaseTerm;
    },

    formatFinanceValue: function(value, valueType) {
        var valueSymbol = Helpers.getChoiceLabel('financeValueTypeChoices', valueType);

        if (value) {
            if (valueSymbol == '$') {
                return Helpers.formatCurrency(value);
            } else if (valueSymbol == '%') {
                return format('{0}%', Helpers.formatNumber(value));
            }

            return value;
        }
    },

    templateHelpers: function() {
        var contacts = this.model.get('contacts');

        return {
            unknownValue: HelperUtils.unknownValue,
            listingLeaseTerm: this.getLeaseTerm(),
            formatFinanceValue: _.bind(this.formatFinanceValue, this),
            isAgentView: this.getOption('viewType') == 'agent',
            isCompanyView: this.getOption('viewType') == 'company',
            isCompanyListing: this.model.get('company').id == this.model.get('listing').building.management_company_id,
            initializeStr: function(str) {
                return initials(str);
            },
            hasContactEmails: contacts.length
                ? _.every(contacts, function(contact) {
                      return contact.email && !contact.is_company;
                  })
                : false,
        };
    },
});

module.exports = DetailView;
